<template>
  <div class="print-sheet-title test-data">
    {{ $t('LBL_TEST_DATA') }}
  </div>
  <div class="test-data-holder">
    <div class="test-data-left">
      {{ $t('TEXT_TEST_DATA_FIRST_SECTION') }}
    </div>
    <div class="test-data-right">
      {{ $t('TEXT_TEST_DATA_SECOND_SECTION') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintTestData'
};
</script>

<style scoped>
.test-data {
  padding-left: 15px;
}
.test-data-holder {
  font-size: 58%;
  display: flex;
}
.test-data-left {
  flex: 1;
  padding-left: 15px;
  padding-right: 10px;
}
.test-data-right {
  padding-left: 10px;
  padding-right: 15px;
  flex: 1;
}
</style>